import createRoute from '@widesk-ui/tools/createRoute';
import FigureModel from '@models/website/FigureModel';

const route = createRoute.splitView(
	'/configuration/figures',
	'website',
	'FigureSplitView',
	FigureModel.localize('plural'),
);
export default route;
